import { render, staticRenderFns } from "./postMortemDetails.vue?vue&type=template&id=ad9cf3f0&scoped=true&"
import script from "./postMortemDetails.vue?vue&type=script&lang=js&"
export * from "./postMortemDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad9cf3f0",
  null
  
)

export default component.exports